const config = {
  api_base_url_stg: "https://hmg-backend.promxa.com/api",
  api_base_url_live: "https://hmg-backend.promxa.com/api",
};
export default config;